import React, { useState } from "react";
import { MapPin, Phone, Mail } from "lucide-react";

import "./ContactPage.css";

const GOOGLE_SCRIPT_URL = process.env.REACT_APP_GOOGLE_SCRIPT_URL;

const ContactPage = () => {
  const [errors, setErrors] = useState({});
  const [form, setForm] = useState({
    name: "",
    mobile: "",
    email: "",
    message: ""
  });

  const [status, setStatus] = useState("idle");
  const [errorMessage, setErrorMessage] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
    validateField(name, value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    setErrorMessage("");

    if (!GOOGLE_SCRIPT_URL || GOOGLE_SCRIPT_URL.includes('AKfycbzO_vZPx')) {
      setStatus("error");
      setErrorMessage("Google Script URL is NOT configured correctly. Please check GOOGLE_SCRIPT_URL.");
      return;
    }

    try {

      await fetch(GOOGLE_SCRIPT_URL, {
        method: "POST",
        mode: "no-cors",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(form)
      });


      setShowSuccess(true);
      setForm({
        name: "",
        mobile: "",
        email: "",
        message: ""
      });
      setStatus("idle");

      // Auto hide toast
      setTimeout(() => {
        setShowSuccess(false);
      }, 4000);

    } catch (err) {
      console.error("Submission error:", err);
      setStatus("error");
      setErrorMessage("Failed to send message. Please try again.");
    }
  };
  const validateField = (name, value) => {
    let error = "";
    if (name === "name") {
      if (value.trim() === "") {
        error = "Name is required";
      } else if (/\d/.test(value)) {
        error = "Numbers not allowed";
      } else if (/[^a-zA-Z\s]/.test(value)) {
        error = "Special characters not allowed";
      }
    }
    if (name === "mobile") {
      if (!/^[0-9]{10}$/.test(value)) {
        error = "Enter valid 10-digit mobile number";
      }
    }
    if (name === "email") {
      if (!/\S+@\S+\.\S+/.test(value)) {
        error = "Enter valid email";
      }
    }
    if (name === "message" && value.trim() === "") {
      error = "Message is required";
    }
    setErrors((prev) => ({
      ...prev,
      [name]: error
    }));
  };
  return (
    <div className="contact">
      {/* HERO */}
      <header className="product-header">
        <div className="header-container">
          <h1 className="service-hero__title">Contact Us</h1>
          <p className="service-hero__desc">
            We offer robust solutions tailored for Defence, Aerospace, and Industrial sectors,
            designed for reliability and crafted with meticulous attention to detail.
          </p>
        </div>
      </header>

      {/* TOP RIGHT TOAST */}
      {showSuccess && (
        <div className="success-toast">
          <div className="success-toast__card">
            <div className="success-toast__icon">✓</div>
            <h3>Success!</h3>
            <p>Your message has been sent successfully. We'll get back to you shortly.</p>
          </div>
        </div>
      )}

      {/* MAIN CONTENT */}
      <main className="page-main">
        <div className="container">
          <div className="contact__container">
            {/* LEFT: Info */}
            <div className="contact__info">
              <h2>Get in touch with us</h2>
              <p>
                Have a project in mind or need technical assistance? Our team is ready to help you with high-performance engineering solutions.
              </p>

              <div className="contact__detail">
                <MapPin className="icon" />
                <div>
                  <h4>Our Location</h4>
                  <p>
                    No.42/43 Jeevarathinam Nagar, Ayapakkam, Chennai - 600077, Tamil Nadu, India
                  </p>
                </div>
              </div>

              <div className="contact__detail">
                <Phone className="icon" />
                <div>
                  <h4>Phone Number</h4>
                  <p>+91 87784 00101</p>
                </div>
              </div>

              <div className="contact__detail">
                <Mail className="icon" />
                <div>
                  <h4>Email Address</h4>
                  <p>info@articzsystems.com</p>
                </div>
              </div>
            </div>

            {/* RIGHT: Form */}
            <div className="contact__formBox">
              <form className="contact__form" onSubmit={handleSubmit}>
                {status === "error" && (
                  <p className="contact__error">
                    {errorMessage}
                  </p>
                )}

                <label>Full Name *</label>
                <input
                  type="text"
                  name="name"
                  placeholder="John Doe"
                  required
                  className={errors.name ? "input--error" : ""}
                  value={form.name}
                  onChange={handleChange}
                />
                {errors.name && <span className="error-text">{errors.name}</span>}

                <label>Mobile *</label>
                <input
                  type="text"
                  name="mobile"
                  placeholder="+91 Your Mobile Number"
                  required
                  className={errors.mobile ? "input--error" : ""}
                  value={form.mobile}
                  onChange={handleChange}
                />
                {errors.mobile && <span className="error-text">{errors.mobile}</span>}

                <label>Email Address *</label>
                <input
                  type="email"
                  name="email"
                  placeholder="yourname@gmail.com"
                  required
                  className={errors.email ? "input--error" : ""}
                  value={form.email}
                  onChange={handleChange}
                />
                {errors.email && <span className="error-text">{errors.email}</span>}

                <label>Message *</label>
                <textarea
                  name="message"
                  placeholder="Describe your use case..."
                  required
                  className={errors.message ? "input--error" : ""}
                  value={form.message}
                  onChange={handleChange}
                />
                {errors.message && <span className="error-text">{errors.message}</span>}

                <button
                  type="submit"
                  className="contact__submit"
                  disabled={status === "loading"}
                >
                  {status === "loading" ? "Sending..." : "Submit"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ContactPage;